import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import HomePage from "./components/HomePages";
import Contact from "./components/Contact";
import Header from "./components/Header";
import Footer from "./components/Footer";
// import AboutUs from "./components/AboutUs";
import NavbarItems from "./components/NavbarItems";
import SocialMediaIcon from "./components/SocialMediaIcon";
import VirtualAssistant from "./components/VirtualAssistant";
import WebsiteDevelopment from "./components/WebsiteDevelopment";
import HRManagement from "./components/HRManagement";
import PageNotFound from "./components/PageNotFound";


function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const [isSocialOpen, setIsSocialOpen] = useState(false);

  const toggleSocial = () => {
    setIsSocialOpen(!isSocialOpen);
  };

  return (
    <div style={{ height: "100%" }}>
      <Header
        isMenuOpen={isMenuOpen}
        toggleMenu={toggleMenu}
        toggleSocial={toggleSocial}
      />
      {/* Left Drawer */}
      {isMenuOpen ? (
        <div className="leftDrawer" onClick={toggleMenu}>
          <NavbarItems isMenuOpen={isMenuOpen} toggleMenu={toggleMenu}/>
        </div>
      ) : (
        ""
      )}
      {/* Right Drawer */}
      {isSocialOpen ? (
        <div className="rightDrawer" onClick={toggleSocial}>
          <SocialMediaIcon isSocialOpen={isSocialOpen} />
        </div>
      ) : (
        ""
      )}
      <Routes>
        <Route exact path="/" element={<HomePage />} />
        <Route path="/contact" element={<Contact/>} />
        <Route path="/VirtualAssistant" element={<VirtualAssistant/>} />
        <Route path="/WebsiteDevelopment" element={<WebsiteDevelopment/>} />
        <Route path="/HRManagement" element={<HRManagement/>} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>

      <Footer />
    </div>
  );
}

export default App;
